export const ROUTES = {
  HOME: '/',
  SHOP: '/shop',
  CART: '/cart',
  EPISODE: '/episode/'
}
